import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useEffectOnce } from 'react-use';
import { useReporting } from '@/reporting';
import QueryBoundaries from '@/shared/components/QueryBoundaries';

const PageTrackerComponent = () => {
  const location = useLocation();
  const { trackEnterpriseEvent } = useReporting();

  // sent when the app loads
  useEffectOnce(() => {
    trackEnterpriseEvent('app::initialized');
  });

  // send when the page changes
  useEffect(() => {
    trackEnterpriseEvent('app::page-change');
  }, [location, trackEnterpriseEvent]);

  return null;
};

const PageTracker = () => (
  <QueryBoundaries>
    <PageTrackerComponent />
  </QueryBoundaries>
);

export default PageTracker;
